<div
  class="product-card__price"
  fxLayout="column nowrap"
  *ngIf="priceType$ | async as priceType"
  test-target="product-card__price"
>
  <ng-container *ngIf="product?.bestOffer as bestOffer; else registerPlaceholder">
    <!--uvp text/strikethrough price, singleUnits & multipleUnits -->
    <div class="product-card__reference-price-container">
      <ng-container *ngIf="singleUnit && bestOffer?.referencePrice">
        <span class="product-card__reference-price">
          {{
            msrpTypeProductReference
              ? ('CATALOG.CATALOG_PAGE.MSRP.LABEL' | translate) + ':'
              : ''
          }}
          <span class="product-card__reference-price--strikethrough">
            <ng-container *ngIf="isUserB2B">
              {{ bestOffer?.referencePrice?.netPrice | currency: bestOffer?.referencePrice?.currency }}
            </ng-container>
            <ng-container *ngIf="!isUserB2B">
              {{
                (priceType == priceTypes.b2b
                    ? bestOffer?.referencePrice?.netPrice
                    : bestOffer?.referencePrice?.grossPrice
                ) | currency: bestOffer?.referencePrice?.currency
              }}
            </ng-container>
          </span>
        </span>
      </ng-container>
      <ng-container *ngIf="multiUnit && bestOffer?.unitPrice?.referencePrice && !msrpTypeProductReference">
        <span class="product-card__reference-price product-card__reference-price--strikethrough">
          <ng-container *ngIf="isUserB2B">
            {{
              bestOffer?.unitPrice?.referencePrice?.netPrice | currency: bestOffer?.unitPrice?.referencePrice?.currency
            }}
          </ng-container>
          <ng-container *ngIf="!isUserB2B">
            {{
              (priceType == priceTypes.b2b
                  ? bestOffer?.unitPrice?.referencePrice?.netPrice
                  : bestOffer?.unitPrice?.referencePrice?.grossPrice
              ) | currency: bestOffer?.unitPrice?.referencePrice?.currency
            }}
          </ng-container>
        </span>
      </ng-container>
    </div>
    <!--main price block-->
    <div
      class="product-card__price-amount__main-price"
      fxLayout="row"
      fxLayoutAlign="start center"
      [ngClass]="{
        'product-card__price-amount__price-color': !product?.bestOffer?.referencePrice?.discountPercentage || product?.bestOffer?.referencePrice?.discountPercentage == number_0,
        'product-card__price-amount__main-price__promotion': product?.bestOffer?.referencePrice?.discountPercentage > number_0
      }"
    >
      <span
        *ngIf="singleUnit"
      >
        <ng-container *ngIf="isUserB2B">
          {{ bestOffer?.price?.netPrice | currency: bestOffer?.price?.currency }}
        </ng-container>
        <ng-container *ngIf="!isUserB2B">
          {{
            (priceType == priceTypes.b2b ? bestOffer?.price?.netPrice : bestOffer?.price?.grossPrice)
              | currency: bestOffer?.price?.currency
          }}
        </ng-container>
      </span>
      <span
        *ngIf="multiUnit"
      >
        <ng-container
          *ngTemplateOutlet="unitPrice; context: { priceType: priceType, unitPrice: bestOffer?.unitPrice }"
        ></ng-container>
      </span>
      <!--Discount Percentage block-->
      <ng-container *ngIf="product?.bestOffer?.referencePrice?.discountPercentage as msrpDiscount">
        <app-product-discount-label [msrpDiscount]="msrpDiscount"
                                    [fromProductCard]="true"></app-product-discount-label>
      </ng-container>
    </div>
    <div class="product-card__totalUnits-base-price" *ngIf="bestOffer?.unitPrice?.unitCount>1 || bestOffer?.basePrice ; else extraPlaceHolder">
      <!-- total units count+ price-->
      <span *ngIf="bestOffer?.unitPrice?.unitCount>1">
        {{ bestOffer?.unitPrice?.unitCount}} {{bestOffer?.price?.unit}}:
        <span *ngIf="isUserB2B"><!--b2b-->
        {{ bestOffer?.price?.netPrice | currency: bestOffer?.price?.currency }}
        </span>
        <span *ngIf="!isUserB2B ">
        {{ bestOffer?.price?.grossPrice | currency: bestOffer?.price?.currency }}
        </span>
      </span>
      <!--base price block-->
      <span *ngIf="bestOffer?.basePrice">
        <ng-container
          *ngTemplateOutlet="basePrice; context: { priceType: priceType, basePrice: bestOffer.basePrice }"
        ></ng-container>
      </span>
    </div>
    <ng-template #extraPlaceHolder>
      <span *ngIf="saveTotalUnitsOrBasePriceSpace" class="margin-bottom-20"></span>
    </ng-template>
  </ng-container>
</div>

<ng-template #registerPlaceholder>
  <span class="product-card__hidden-price">{{
    'CATALOG.CATALOG_PAGE.PRODUCT-CARD.B2B_OFFER_ONLY.LABEL' | translate
  }}</span>
</ng-template>
<ng-template #unitPrice let-priceType="priceType" let-unitPrice="unitPrice">
  <ng-container *ngIf="isUserB2B">
    {{ unitPrice?.price?.netPrice | currency: unitPrice?.price?.currency }}
  </ng-container>
  <ng-container *ngIf="!isUserB2B">
    {{ unitPrice?.price?.grossPrice | currency: unitPrice?.price?.currency }}
  </ng-container>
  <span class="product-card__price-amount__main-price-unit" *ngIf="unitPrice?.price?.unit">
    {{priceSeperator}} {{ unitPrice?.price?.unit }}
  </span>
</ng-template>
<ng-template #basePrice let-priceType="priceType" let-basePrice="basePrice">
  <ng-container *ngIf="isUserB2B">
    {{ basePrice?.netPrice | currency: basePrice?.currency }}/{{ basePrice?.unit }}
  </ng-container>
  <ng-container *ngIf="!isUserB2B">
    {{
    (priceType === priceTypes.b2b ? basePrice?.netPrice : basePrice?.grossPrice)
      | currency: basePrice?.currency
    }}/{{ basePrice?.unit }}
  </ng-container>
</ng-template>
